import {
  Container,
  styled,
  Box,
} from "@mui/material";
import FirmForm from "components/FirmForm/FirmForm";
import { useNavigate } from "react-router-dom";

const AddFirmPage = () => {
  const navigate = useNavigate();

  const handleFormSubmit = (firmName, firmAdminName) => {
    navigate('/firms?modal=open&modalType=addFirmSuccess', { state: { firmName, firmAdminName } });
  };

  return (
    <StyledContainer>
      <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.12)', borderRadius: 5, padding: 20, paddingLeft: 41, paddingTop: 37 }}>
        {/* <Box sx={{width:"26%"}}> */}
        <Box sx={{ width: "365px" }}>
          <div style={{ width: '100%', height: '100%', color: '#1A1A1A', fontSize: 28, fontFamily: 'Helvetica Neue LT Std', fontWeight: '300', wordWrap: 'break-word', paddingBottom: 12 }}>Add New Firm</div>
          <FirmForm onSuccess={handleFormSubmit} onClose={() => navigate("/firms")} />
        </Box>
      </div>
    </StyledContainer>
  );
};

export default AddFirmPage;

const StyledContainer = styled(Container)({
  marginBottom: 24,
});